/** @jsxImportSource @emotion/react */
import React from 'react';
import type { DivProps } from 'typings';
import * as S from './styles';
import UDInput from 'ud-form/components/input/component';
import Label from 'ud-ui/components/label';
import { Search } from 'lucide-react';
import { UDSelect } from 'ud-form/components';
import { STATUS_FILTER_OPTIONS } from 'modules/roles-manager/domain/interfaces/status';
import UDPerPage from 'ud-ui/components/per-page/per-page';

interface IHeaderProps extends DivProps {
  perPage: number;
  search: string | null;
  status: boolean | null;
  phone: string | null;
  onChangePerPage: (value: number) => void;
  onChangeSearch?: (value: string) => void;
  onChangeStatus?: (value: boolean | null) => void;
  onChangePhone?: (value: string | null) => void;
}

function Header(props: IHeaderProps) {
  const { perPage, search, status, phone, onChangePerPage, onChangeSearch, onChangeStatus, onChangePhone, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <div className="flex gap-3.5">
        <Label text="Поиск по ФИО:" className="w-[250px]">
          <UDInput
            value={search ?? ''}
            name="name"
            placeholder={'Иванов Иван Иванович'}
            onChange={(value) => onChangeSearch?.(value.target.value)}
            iconProps={{
              component: <Search size={16} className="text-surfaceRomanSilver30" />,
              position: 'icon-right',
            }}
          />
        </Label>
        <Label text="Поиск по последним 4 циф. телефона:" className="w-[310px]">
          <UDInput
            value={phone ?? ''}
            name="phone"
            placeholder={'0000'}
            onChange={(value) => onChangePhone?.(value.target.value)}
            iconProps={{
              component: <Search size={16} className="text-surfaceRomanSilver30" />,
              position: 'icon-right',
            }}
          />
        </Label>
        <Label text="Статус" className="w-[160px]">
          <UDSelect
            value={STATUS_FILTER_OPTIONS.find((o) => o.value === status) ?? STATUS_FILTER_OPTIONS[0]}
            name="name"
            placeholder={'Статус'}
            onChange={(option) => onChangeStatus?.(option?.value ?? null)}
            options={STATUS_FILTER_OPTIONS}
            defaultValue={STATUS_FILTER_OPTIONS[0]}
          />
        </Label>
      </div>
      <div className="items-end justify-end flex w-1/2">
        <UDPerPage value={perPage} onChange={onChangePerPage} />
      </div>
    </S.MainBlock>
  );
}

export default Header;
